export enum SymbolType {
  Bonus = 0, // C1
  SuperBonus = 1, // C2
  Multiplier = 2, // S1
  M1 = 3,
  M2 = 4,
  M3 = 5,
  M4 = 6,
  M5 = 7,
  A = 8,
  K = 9,
  Q = 10,
  J = 11,
}
